export default __webpack_public_path__ + "static/media/document.fd29df9a.png";